export const LIFECYCLE_STATUSES = ["ACTIVE", "RETIRED"];

export const EXTERNAL_CODE_SYSTEMS = [
  "SNOMED",
  "ICD10",
  "ICD11",
  "CVX",
  "MVX",
  "LOINC",
  "ABDM",
  "NRCES",
];

export const VACCINE_NATURES = [
  "LIVE_ATTENUATED",
  "INACTIVATED",
  "TOXOID",
  "SUBUNIT",
  "CONJUGATE",
  "POLYSACCHARIDE",
  "VIRAL_VECTOR",
  "MRNA",
  "IMMUNOGLOBULIN",
  "OTHER",
];

export const SCHEDULE_TYPES = [
  "ROUTINE_PEDIATRIC",
  "ROUTINE_ADULT",
  "RISK_BASED",
  "POST_EXPOSURE",
  "TRAVEL",
  "OCCUPATIONAL",
  "OUTBREAK",
];

export const SCHEDULE_ANCHORS = [
  "BIRTH",
  "DIAGNOSIS",
  "EXPOSURE",
  "PREGNANCY_EDD",
  "EMPLOYMENT_START",
  "TRAVEL_DATE",
  "SEASON",
  "ENROLMENT",
];

export const SCHEDULE_TYPE_FORCED_ANCHOR = {
  POST_EXPOSURE: "EXPOSURE",
  TRAVEL: "TRAVEL_DATE",
  OCCUPATIONAL: "EMPLOYMENT_START",
  ROUTINE_PEDIATRIC: "BIRTH",
};

export const DOSE_REQUIREMENT_LEVELS = [
  "MANDATORY",
  "OPTIONAL",
  "CONDITIONAL",
];

export const SEX_ELIGIBILITY = ["ANY", "MALE", "FEMALE"];

export const CONTRAINDICATION_TYPES = ["ABSOLUTE", "PRECAUTION", "FALSE"];

export const COHORT_RULE_SOURCES = [
  "CHRONIC_DISEASE",
  "DIAGNOSIS",
  "CDSS_FLAG",
  "LAB_VALUE",
  "AGE",
  "GENDER",
  "OCCUPATION",
  "PREGNANCY",
  "MANUAL",
];

export const FIELD_BEARING_SOURCES = [
  "CHRONIC_DISEASE",
  "DIAGNOSIS",
  "CDSS_FLAG",
  "LAB_VALUE",
];

export const COHORT_RULE_OPERATORS = [
  "EQUALS",
  "NOT_EQUALS",
  "CONTAINS",
  "GREATER_THAN",
  "GREATER_THAN_OR_EQUAL",
  "LESS_THAN",
  "LESS_THAN_OR_EQUAL",
  "BETWEEN",
  "EXISTS",
];

export const COHORT_RULE_LOGIC = ["ANY", "ALL"];

export const VACCINATION_STATUSES = [
  "COMPLETED",
  "NOT_DONE",
  "ENTERED_IN_ERROR",
];

export const LATERALITIES = ["LEFT", "RIGHT", "BILATERAL", "NOT_APPLICABLE"];

export const NUMERATOR_RULES = [
  "ALL_ANTIGENS",
  "ANY_ANTIGEN",
  "PER_ANTIGEN",
];

export const GST_PERCENTS = [0, 5, 12, 18, 28];

export const DEFAULT_DOSE_GRACE_DAYS = 4;

export const humanise = (value) =>
  String(value || "")
    .replace(/_/g, " ")
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
